// The shared Amount Qualifier Code list (DE 522) — used by every AMT01
// across transaction sets. Union of the existing AMT01 codes and the 844's,
// per reference/session/844-product-transfer-account-adjustment-qualifiers-
// txt.md. The home for this DE going forward: a future transaction set's
// AMT01 should extend this list rather than defining its own.

import type {CodeListEntry} from './types';

export const AMOUNT_QUALIFIER_CODES: CodeListEntry[] = [
  {code: 'TT', label: 'Total'},
  {code: 'DA', label: 'Discount Amount'},
  {code: '1', label: 'Line Item Total'},
  {code: 'LI', label: 'Line Item Unit Price'},
  {code: 'N', label: 'Net'},
  {code: 'GV', label: 'Gross Value'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
